<template>
  <div>
    <div class="video-col-left">
      <transition name="fade">
        <div class="video-item" v-if="localTracks.length > 0">
          <DemoVideoComponent
            ref="localVideoComponentInstance"
            :playerUsername="playerUsername"
            :gameState="gameState"
            :isHost="isHost"
            :tracks="localTracks"
            :isLocalAudioMuted="isLocalAudioMuted"
            :isLocalVideoMuted="isLocalVideoMuted"
            :localPlayerHasAnswered="localPlayerHasAnswered"
            :localPlayerHasVoted="localPlayerHasVoted"
            :primaryColor="primaryColor"
            :secondaryColor="secondaryColor"
            :backgroundColor="backgroundColor"
            @play-sound-effect="propagateEvent('play-sound-effect', $event)"
          />
        </div>
      </transition>
      <div
        class="video-item"
        v-for="remoteParticipant in leftSideRemoteParticipants"
        :key="remoteParticipant.identity"
      >
        <DemoRemoteVideoComponent
          :gameState="gameState"
          :participant="remoteParticipant"
          @play-sound-effect="propagateEvent('play-sound-effect', $event)"
        />
      </div>
    </div>
    <div class="video-col-right">
      <div
        class="video-item"
        v-for="remoteParticipant in rightSideRemoteParticipants"
        :key="remoteParticipant.identity"
      >
        <DemoRemoteVideoComponent
          :gameState="gameState"
          :participant="remoteParticipant"
          @play-sound-effect="propagateEvent('play-sound-effect', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import DemoVideoComponent from '@/components/demoComponents/DemoVideoComponent';
import DemoRemoteVideoComponent from '@/components/demoComponents/DemoRemoteVideoComponent';

export default Vue.extend({
  name: 'VideoView',
  components: {
    DemoVideoComponent,
    DemoRemoteVideoComponent
  },
  props: {
    playerUsername: String,
    localTracks: Array,
    gameState: Object,
    isHost: Boolean,
    isLocalAudioMuted: Boolean,
    isLocalVideoMuted: Boolean,
    primaryColor: String,
    secondaryColor: String,
    backgroundColor: String
  },
  data: () => ({
    remoteParticipants: [],
    profileImages: [],
    localPlayerHasAnswered: false,
    localPlayerHasVoted: false
  }),
  watch: {
    gameState: function () {
      this.getRemoteParticipants();
    },
    remoteParticipants: function() {
      this.$nextTick(function() {
        window.dispatchEvent(new Event('resize'));
      });
    }
  },
  computed: {
    leftSideRemoteParticipants: function () {
      const leftParticipants = [];
      for (let i = 1; i < this.remoteParticipants.length; i += 2) {
        leftParticipants.push(this.remoteParticipants[i]);
      }
      return leftParticipants;
    },
    rightSideRemoteParticipants: function () {
      const rightParticipants = [];
      for (let i = 0; i < this.remoteParticipants.length; i += 2) {
        rightParticipants.push(this.remoteParticipants[i]);
      }
      return rightParticipants;
    },
  },
  methods: {
    getRemoteParticipants() {
      if (!this.gameState.playerUserIds || this.gameState.playerUserIds.length <= 1) {
        return;
      }
      let temp = []
      for(let i = 1; i < this.gameState.playerUserIds.length; i++) {
        let participant = {
          identity: this.gameState.playerUserIds[i],
          userName: this.gameState.playerUsernames[i],
          hasAnswered: false,
          hasVoted: false,
          joinedIndex: this.remoteParticipants.length + 2
        }
        temp.push(participant)
      }
      this.remoteParticipants = temp;
      // console.log('remoteparticipants', this.remoteParticipants);
    },
    setPlayerHasAnswered (identity) {
      this.remoteParticipants.forEach(participant => {
        if (participant.identity === identity) {
          participant.hasAnswered = true;
        }
      });
    },
    setPlayerHasVoted (identity) {
      this.remoteParticipants.forEach(participant => {
        if (participant.identity === identity) {
          participant.hasVoted = true;
        }
      });
    },
    resetPlayersHaveAnswered () {
      this.localPlayerHasAnswered = false;
      this.remoteParticipants.forEach(participant => {
        participant.hasAnswered = false;
      });
    },
    resetPlayersHaveVoted () {
      this.localPlayerHasVoted = false;

      this.remoteParticipants.forEach(participant => {
        participant.hasVoted = false;
      });
    },
    propagateEvent(eventName, eventData) {
      this.$emit(eventName, eventData);
    }
  },
  mounted: function () {
    this.$nextTick(function() {
      this.getRemoteParticipants();
      // console.log('remoteparticipants', this.remoteParticipants);
    });
  },
  beforeDestroy: function () {
    this.remoteParticipants = [];  // destroy all remote video components
  }
})
</script>

<style lang="scss">
@import '@/styles/video-view-styles.scss';
</style>
